import { createContext } from 'react';

const TranslatorContext = createContext();

export default TranslatorContext;
